import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

export interface AvailableMembershipPlan {
  id: string
  name: string
  amountCents: number
  durationMonths: number
  internalOnly: boolean
}

export const getAvailableMembershipPlans = async (
  userId?: string,
): Promise<AvailableMembershipPlan[]> => {
  const { data, errors } = await arriereBackoffice.queries.availableMembershipPlans.raw({
    __alias: 'getAvailableMembershipPlans',
    __args: { userId },
    id: true,
    name: true,
    amountCents: true,
    durationMonths: true,
    internalOnly: true,
  })

  if (errors?.length) throw new Error(errors[0]?.message)

  return data ?? []
}
